/* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages */
import { defineMessages } from 'react-intl-next';

export const spotlighti18n = defineMessages({
	okButton: {
		id: 'editor-ellipsis-dropdown.content-creation-panel.spotlight.ok-button',
		defaultMessage: 'OK',
		description: 'Text for the button that dismisses a spotlight around the ellipsis menu',
	},
	spotlightText: {
		id: 'editor-ellipsis-dropdown.content-creation-panel.spotlight.text',
		defaultMessage:
			'Select <b>Templates &amp; import doc</b> from the more actions menu to reopen the panel.',
		description: 'Text for the ellipsis menu spotlight',
	},
});

export const livePagesi18n = defineMessages({
	viewChangesTitle: {
		id: 'editor-ellipsis-dropdown.ellipsis.open.ellipsis.view.changes.title',
		description: 'heading of view changes dialog in a live page',
		defaultMessage: 'Latest changes',
	},
	copy: {
		id: 'editor-ellipsis-dropdown.ellipsis.open.ellipsis.copy',
		description: 'The label of Copy button inside ellipsis dropdown of the live pages editor',
		defaultMessage: 'Copy',
	},
	export: {
		id: 'editor-ellipsis-dropdown.ellipsis.open.ellipsis.export',
		description:
			'The text that is displayed in the menu dropdown that group Export to PDF and Export to Word',
		defaultMessage: 'Export',
	},
	advanced: {
		defaultMessage: 'Advanced details',
		id: 'editor-ellipsis-dropdown.ellipsis.open.ellipsis.advanced',
		description:
			'The text that display in the live pages advanced details menu dropdown that group Page Information, Page Information, View Source and View Content API',
	},
	publish: {
		id: 'editor-ellipsis-dropdown.ellipsis.open.ellipsis.publish',
		description: 'The label of Publish button inside ellipsis dropdown of the live pages editor',
		defaultMessage: 'Publish',
	},
	publishDots: {
		id: 'editor-ellipsis-dropdown.ellipsis.open.ellipsis.publish-dots',
		description: 'The label of Publish button inside ellipsis dropdown of the live pages editor, when a modal will open after it is clicked',
		defaultMessage: 'Publish...',
	},
	archive: {
		id: 'editor-ellipsis-dropdown.ellipsis.open.ellipsis.archive',
		description: 'The label of Archive button inside ellipsis dropdown of the live pages editor',
		defaultMessage: 'Archive',
	},
	attachments: {
		id: 'editor-ellipsis-dropdown.ellipsis.open.ellipsis.attachments',
		description: 'The text that display in the menu dropdown that group Files and Custom Contents',
		defaultMessage: 'Attachments',
	},
	files: {
		id: 'editor-ellipsis-dropdown.ellipsis.open.ellipsis.files',
		defaultMessage: 'Files',
		description:
			'The text for Files that display in the menu dropdown that group Files and Custom Contents',
	},
	customContents: {
		id: 'editor-ellipsis-dropdown.ellipsis.open.ellipsis.custom.contents',
		defaultMessage: 'Custom Contents',
		description:
			'The text for Custom Contents that display in the menu dropdown that group Files and Custom Contents',
	},
	pageApps: {
		id: 'editor-ellipsis-dropdown.ellipsis.open.ellipsis.page.apps',
		defaultMessage: 'Apps',
		description:
			'The text in dropdown menu that displays all the apps that are available for the page',
	},
});
